import HeadingText from "../atoms/HeadingText";
import MnLink from "../atoms/MnLink";
import footerImage from "../../assets/images/footer2.avif";
import { useTranslation } from "react-i18next";

export default function ContactUs() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 my-12">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${footerImage})`,
          opacity: 0.1,
          zIndex: -1,
        }}
      />
      <div className="max-w-6xl mx-auto px-4 ">
        <div className="flex flex-col items-center justify-center">
          <HeadingText variant="h2">
            {t("homepage.contactUs.heading")}
          </HeadingText>
          <HeadingText variant="h3" classes="!mb-14">
            {t("homepage.contactUs.subheading")}
          </HeadingText>

          <MnLink
            variant="primary"
            to="/get-in-touch"
            name={t("homepage.contactUs.linkText")}
            classes="text-lg mb-0"
          />
        </div>
      </div>
    </section>
  );
}
